import {ReduxStateType} from '../store';

export const selectTaxFormsReducer = (state: ReduxStateType) => state.taxForms;
export const selectTaxForms = (state: ReduxStateType) => state.taxForms.taxForms;
